import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const SkillApiResources = {
  list:  createUrl('skills'),
  create:  createUrl('skills/create'),
  detail:  createUrl('skills'),
  update:  createUrl('skills'),
  delete:  createUrl('skills'),
};
